import {defineAsyncComponent} from 'vue';

export {Splide, SplideSlide, SplideTrack} from '@splidejs/vue-splide';
export {default as AnnouncementBar} from './AnnouncementBar.vue';
export {default as VIcon} from './VIcon.vue';
export {default as VImage} from './VImage.vue';
export {default as VModal} from './VModal.vue';

export const CartDrawer = defineAsyncComponent(() => import('./CartDrawer.vue'));
export const SearchBar = defineAsyncComponent(() => import('./SearchBar.vue'));
export const StorePicker = defineAsyncComponent(() => import('./StorePicker.vue'));
export const VAccordion = defineAsyncComponent(() => import('./VAccordion.vue'));
export const VGrid = defineAsyncComponent(() => import('./VGrid.vue'));
export const VVideo = defineAsyncComponent(() => import('./VVideo.vue'));
export const VCounter = defineAsyncComponent(() => import('./VCounter.vue'));
export const FeaturedCollection = defineAsyncComponent(() => import('./FeaturedCollection.vue'));
export const GeoPopup = defineAsyncComponent(() => import('./GeoPopup.vue'));
export const CustomDiscounts = defineAsyncComponent(() => import('./CustomDiscounts.vue'));
export const LogoSlider = defineAsyncComponent(() => import('./LogoSlider.vue'));
export const MegaMenu = defineAsyncComponent(() => import('./MegaMenu.vue'));
export const RegisterNoteInputs = defineAsyncComponent(() => import('./RegisterNoteInputs.vue'));
